import React from 'react'
import "./BlogPost.css";

import mub from "../../Assets/b71/mub.jpg"

function Blog71() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>On this blessed occasion of Eid El-Fitr</h1>
                    <h6>March 20, 2026 at 12:00 PM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <img src={mub} className="blog-img" alt="..." />
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>We extend our warmest greetings to everyone celebrating. May this sacred day fill your hearts with peace, your homes with joy, and your lives with renewed faith, love, and gratitude. Eid Mubarak</p>
                    <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
                        #MYTSoftDevSolutions</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog71;
